import DiscordLogo from './DiscordLogo';

export default DiscordLogo;
